<template>
  <header
      class="mdc-top-app-bar view-header"
      :style="
      surveyData.image
        ? `background-image: url(${surveyData.image}?s=360x256&t=fill&q=10&b=5);`
        : ''
    "
      :class="surveyData.image ? 'darken' : ''"
      v-if="surveyData"
  >
    <div class="mdc-top-app-bar__row">
      <section
          class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start"
      >
        <a
            class="material-icons mdc-top-app-bar__navigation-icon"
            @click="routerGoPrev()"
        >arrow_back</a
        >
      </section>

      <section class="mdc-top-app-bar__section title">
        <div class="mdc-top-app-bar__title"></div>
      </section>

      <section
          class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end"
      >
        <!-- <a
          class="material-icons mdc-top-app-bar__action-item"
          aria-label="search"
          alt="search"
        ></a> -->
      </section>
    </div>

    <div class="pdt-16 pdb-20 pdl-16 pdr-16">
      <div class="t-headline14">
        {{ surveyData.name }}
        <!-- 비즈니스 전문가 시험: 예측 가능한 분석 -->
      </div>
      <div class="t-body4 mgt-8" v-if="surveyData.category">
        {{ surveyData.category.text }}
        <!-- 시험지분류1-->
      </div>

      <div class="t-helper mgt-9 d-flex flex-row" v-if="surveyData.tags.length">
        <!-- <span
          class="chip mgr-8"
          v-for="(tag, index) in surveyData.tags"
          :key="index"
          >#{{ tag.name }}</span
        > -->
        <div class="mdc-chip-set " role="grid">
          <div class="mdc-chip mdc-chip-outline" role="row"  v-for="(tag, index) in surveyData.tags"  :key="index">
            <div class="mdc-chip__ripple"></div>
            <span role="gridcell">
                  <span class="mdc-chip__text">#{{tag.name}}</span>
              </span>
          </div>
        </div>
      </div>

      <div class="mgt-21" v-if="surveyData.point.totalPoint > 0">
        <div class="d-flex justify-content-between align-items-baseline">
          <span class="t-body3">{{ $t("222") }}</span>
          <div
              class="d-flex justify-content-between align-items-center t-headline5"
          >
            <img
                src="@/assets/icon_point.svg"
                alt=""
                class="icon mgr-4 mgl-4"
            />
            {{ $n(surveyData.point.totalPoint) }}
          </div>
        </div>
      </div>

      <div v-if="isAuthToken">
        <div class="mgt-20">
          <button
              class="mdc-button mdc-button--raised btn-red w-full btn-big"
              disabled
              v-if="surveyData.progression.value === 'WAITING'"
          >
            {{ $t("703") }}
            <!-- 설문 참여 기간 아님 -->
          </button>
          <button
              class="mdc-button mdc-button--raised btn-red w-full btn-big"
              @click="takeSurvey(surveyData.progression.value)"
              v-if="surveyData.progression.value === 'APPLICATION'"
          >
            {{ $t("223") }}
            <!-- 참여하기 -->
          </button>

          <button
              class="mdc-button mdc-button--raised btn-red w-full btn-big"
              @click="takeSurvey(surveyData.progression.value)"
              v-if="surveyData.progression.value === 'RESPONDENT'"
          >
            {{ $t("3091") }}
            <!-- 응답하기 -->
          </button>

          <button
              class="mdc-button mdc-button--raised btn-red w-full btn-big"
              @click="moveSurveyResult()"
              v-if="surveyData.progression.value === 'RESPONDING'"
          >
            {{ $t("3091") }}
            <!-- 지난 결과 확인 -->
          </button>
          <button
              class="mdc-button mdc-button--raised btn-red w-full btn-big"
              @click="moveSurveyResult()"
              v-if="surveyData.progression.value === 'SUBMITTED'"
          >
            {{ $t("752") }}
            <!-- 지난 결과 확인 -->
          </button>

          <button
              class="mdc-button mdc-button--raised btn-red w-full btn-big"
              disabled
              v-if="surveyData.progression.value === 'NONRESPONSE'"
          >
            {{ $t("703") }}
            <!-- 설문 참여 기간 아님 -->
          </button>
        </div>
      </div>

      <div v-else>
        <div class="mgt-20">
          <button
              class="mdc-button mdc-button--raised btn-red w-full btn-big"
              @click="takeSurvey()"
          >
            {{ $t("3091") }}
            <!-- 참여하기 -->
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import httpService from "@/api/httpService";
// import loginApi from '@/api/loginApi.js'
import surveyApi from "@/api/surveyApi.js";
import {MDCRipple} from '@material/ripple'
import {MDCChipSet} from '@material/chips';
// Mixin 선언
import { surveyMixin } from "@/mixins/survey.js";

/*
WAITING 참여대기 참여 가능한 기간 이전 상태

APPLICATION 참여가능 참여 가능한 기간이지만 참여하지 않은 상태

RESPONDENT 응답가능 참여 후 아직 응답하지 않았지만 요청일이 응답일 내에 있는 상태

RESPONDING 응답중 응답기간 내에 설문 응답 시작을 하고 제출 이전

SUBMITTED 제출 설문을 제출한 상태

NONRESPONSE 미응시 설문 응시를 하지 않고 기간이 지난 상태
*/
export default {
  props: ["surveyData"],
  data() {
    return {
      authToken: "",
      distId: "",
      respondentId: "",
    };
  },

  mixins: [surveyMixin],

  mounted() {
    this.$nextTick(function (obj) {
      this.setMaterialUi();
      console.log("this.surveyData : ", this.surveyData);
      if (this.surveyData && this.surveyData.tags && this.surveyData.tags.length) {
        const chipSetEl = document.querySelector('.mdc-chip-set');
        const chipSet = new MDCChipSet(chipSetEl);
      }
    });
  },

  updated() {
    this.authToken = localStorage.getItem("token");
    this.distId = this.surveyData.id;
    this.respondentId = this.surveyData.respondentId;
    // console.log('authToken', this.authToken);

  },

  computed: {
    isAuthToken() {
      return !!this.authToken;
    },
  },

  methods: {
    async takeSurvey(progression) {
      let authStatus = await this.checkLogin();
      if (authStatus) {

        if (progression === "APPLICATION") {
          let params = {
            distId: this.distId,
          };
          surveyApi.surveyIndependentEnter(params).then((response) => {
            this.respondentId = response.data.data.id;
            // console.log("surveyIndependentEnter", response.data.data);
            this.moveSurveyIntro();
          });
        } else if (progression === "RESPONDENT") {
          this.moveSurveyIntro();
        } else if (progression === "RESPONDING") {
          this.moveSurveyIntro();
        } else if (progression === "SUBMITTED") {
          this.moveSurveyIntro();
        } else if (progression === "NONRESPONSE") {
        }
      } else {
        this.moveLogin();
      }
    },

    // checkLogin() {
    //     // httpService.setAuthInHeader(localStorage.getItem('token'))
    //     return new Promise((resolve, reject) => {
    //         loginApi.validToken().then((response) => {
    //             resolve(true)
    //         }).catch((err) => {
    //             resolve(false)
    //         })
    //     })

    // },

    moveLogin() {
      const loginPath = `/login?redirectPath=${encodeURIComponent(
          this.$route.fullPath
      )}`;
      this.$router.push(loginPath);
    },

    moveSurveyIntro() {
      let params = {
        distId: this.distId,
        respondentId: this.respondentId,
      };

      this.$router.push({
        name: "IndependentSurveyIntro",
        params: params,
      });
    },
    setMaterialUi() {
      const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
        let button = new MDCRipple.attachTo(el)
        return button
      })
    },
  },

};
</script>

<style>
</style>
